import { Button, Result } from "antd";
import { Link } from "react-router-dom";
import { Screens } from "@constants/screens";
import { TranslationService } from "@services/translate";

const ErrorScreen = (): JSX.Element => (
  <Result
    status="500"
    title="500"
    subTitle={TranslationService.t("txt_screen_error")}
    extra={
      <Button type="primary">
        <Link to={Screens.Root.path()}>{TranslationService.t("txt_back")}</Link>
      </Button>
    }
  />
);

export default ErrorScreen;
